// @flow

import classnames from 'classnames';
import * as React from 'react';
import SvgInline from '@latitude/svg-inline';
import './_hamburger-button.scss';

type Props = {
  className?: string,
  navOpen: boolean, // true if navigation is open
  onClick: () => void
};

type Ref = {current: null | HTMLElement};

// Use ref forwarding to obtain a ref to the <button> element
// https://reactjs.org/docs/forwarding-refs.html
const HamburgerButton = React.forwardRef((props: Props, ref: Ref) => {
  const { className, navOpen, onClick } = props;
  return (
    <button
      ref={ref}
      type="button"
      className={classnames('hamburger-button', className, {
        'is-active': navOpen
      })}
      onClick={onClick}
    >
      {navOpen ? (
        <SvgInline
          className="icon__cross"
          name="cross"
          ariaLabel="close menu "
        />
      ) : (
        <SvgInline
          className="icon__hamburger"
          name="menu"
          ariaLabel="open menu"
        />
      )}
    </button>
  );
});

export default HamburgerButton;
